import { render } from "./EditRooms.vue?vue&type=template&id=e83e9190"
import script from "./EditRooms.vue?vue&type=script&lang=js"
export * from "./EditRooms.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__